import { Fragment, useEffect, useState } from "react";
import { getVariable, setVariable } from "../../Helpers/Session";
import Button from "../../components/Button";
import { NavLink } from "react-router-dom";
import SearchBar from "../../components/SearchBar";
import DocumentMeta from "react-document-meta";
import ListItem from "../../components/Listitem";
function ItemList() {
  const [cartTotal, setCartTotal] = useState(0);
  const [qtyTotal, setQtyTotal] = useState(0);
  const [items, setItems] = useState(getVariable("itemsArr", true) || []);
  const [addtoCartItems, setAddtoCartItems] = useState(
    getVariable("selItems", true) || []
  );
  const cartItems = getVariable("cartItems", true) || [];
  const curSymbol = getVariable("curSymbol", true);
  const itemsArr = getVariable("itemsArr", true) || [];
  const [disableButton, setDisableButton] = useState(true);
  const calculateTotalAmt = (updateArr = []) => {
    let grandTotal = 0;
    let totalQty = 0;
    if (updateArr?.length > 0) {
      updateArr.map((value, index) => {
        grandTotal +=
          parseFloat(value.fUnitRate) *
          parseFloat(value.cartQuantity ? value.cartQuantity : 1);
        totalQty += parseFloat(value.cartQuantity);
      });
      setCartTotal(grandTotal.toFixed(2));
      setQtyTotal(totalQty);
    }
  };
  const [searchVal, setSearchVal] = useState("");
  useEffect(() => {
    let grandTotal = 0;
    let qtyTotal = 0;
    let updatedCart = cartItems.filter((cartItem) =>
      addtoCartItems.includes(cartItem.pkid)
    );

    addtoCartItems.forEach((itemId) => {
      const item = itemsArr.find((value) => value.pkid === itemId);
      if (item) {
        grandTotal += parseFloat(item.fUnitRate);
        qtyTotal += parseFloat(item.cartQuantity);
        if (!updatedCart.some((cartItem) => cartItem.pkid === item.pkid)) {
          updatedCart.push({
            // ...item,
            pkid: item.pkid,
            itemTitle: item.itemTitle,
            product_image: item.product_image,
            unitMasterName: item.unitMasterName,
            fUnitRate: item.fUnitRate,
            fIGST: item.fIGST,
            fCGST: item.fCGST,
            fSGST: item.fSGST,
            fMinBuyQty: (parseFloat(item?.fMinBuyQty) > 0) ?  item.fMinBuyQty : 1,
            cartQuantity: (parseFloat(item?.fMinBuyQty) > 0) ?  item.fMinBuyQty : 1,
          });
        }
      }
    });
    setQtyTotal(qtyTotal);
    setCartTotal(grandTotal.toFixed(2));
    setDisableButton(addtoCartItems.length === 0);
    setVariable("cartItems", updatedCart, true);
    calculateTotalAmt(updatedCart.length > 0 ? updatedCart : addtoCartItems);
    setVariable("selItems", addtoCartItems, true);

    // Only sort when there is NO active search
    if (!searchVal) {
      const sortedItems = [...itemsArr].sort(
        (a, b) =>
          addtoCartItems.includes(b.pkid) - addtoCartItems.includes(a.pkid)
      );
      setItems(sortedItems);
    }
  }, [addtoCartItems, searchVal]);

  const selectedItem = (checked, id) => {
    setAddtoCartItems((prevItems) => {
      if (checked && !prevItems.includes(id)) {
        return [...prevItems, id]; // Only add if it's not already there
      } else {
        return prevItems.filter((item) => item !== id); // Remove item if unchecked
      }
    });
  };

  const onSearch = (event) => {
    let searchTerm = event.target.value.toLowerCase();
    setSearchVal(searchTerm);
    setItems(
      searchTerm
        ? itemsArr.filter((row) =>
            row.itemTitle.toLowerCase().includes(searchTerm)
          )
        : itemsArr
    );
  };

  const documentMeta = {
    title: "Item List",
  };

  return (
    <DocumentMeta {...documentMeta}>
      <div className="product-listing-page">
        <SearchBar onSearch={onSearch} />
        <ul className="product-list">
          {items.length > 0 &&
            items.map((item) => (
              <Fragment key={item.pkid}>
                <ListItem
                  {...item}
                  page="itemlist"
                  selectedItem={selectedItem}
                  addtoCartItems={addtoCartItems}
                  checkedItem={addtoCartItems.includes(item.pkid)}
                />
              </Fragment>
            ))}
        </ul>
        <div className="page-footer">
          <div style={{ display: "flex", alignItems: "center", gap: "15px" }}>
            <div className="summary">
              <label>
                Cart Amount{" "}
                <small className="text-primary">(Qty : {qtyTotal.toFixed(3)})</small>
              </label>
              <div className="total">
                {curSymbol} {cartTotal}
              </div>
            </div>
          </div>
          <NavLink to="/placeorder">
            <Button
              className="bg-blue-400 p-2 w-40 rounded text-white"
              title="Add To Cart"
              type="button"
              disabled={disableButton}
            />
          </NavLink>
        </div>
      </div>
    </DocumentMeta>
  );
}

export default ItemList;
